export default __webpack_public_path__ + "static/media/Pickpocket's Bracers of the Hidden Palace.9d201af7.jpg";